import CryptoJS from 'crypto-js';

// export const key = '/MWQQ1yhgcxsNWYrK2Ilgw=='; // 密码
// export const iv = 'XSREHygEO1Sz6mSt293RnQ=='; // 偏移量

// // 3DES 加密
// export const encryptByDES = (dataStr) => {
// 	// const keyHex = CryptoJS.enc.Utf8.parse(key);
// 	// const encrypted = CryptoJS.TripleDES.encrypt(dataStr, keyHex, {
// 	//   mode: CryptoJS.mode.CBC, // CBC模式
// 	//   padding: CryptoJS.pad.Pkcs7, // pkcs7padding 填充方式
// 	//   iv: CryptoJS.enc.Utf8.parse(iv) // 设置偏移量（若 ECB 模式则删除该行）
// 	// });
// 	// // return encrypted.ciphertext.toString(); // 返回 hex 编码格式
// 	// return encrypted.toString(); // 返回 base64 编码格式
// 	let srcs = CryptoJS.enc.Utf8.parse(dataStr);
// 	let encrypted = CryptoJS.AES.encrypt(srcs, key, {
// 		iv: iv,
// 		mode: CryptoJS.mode.CBC,
// 		padding: CryptoJS.pad.Pkcs7
// 	});
// 	return encrypted.toString();
// }

// // 3DES 解密
// export const decryptByDES = (ciphertext) => {
// 	// const keyHex = CryptoJS.enc.Utf8.parse(key);
// 	// const decrypted = CryptoJS.TripleDES.decrypt({
// 	// 	// ciphertext: CryptoJS.enc.Hex.parse(ciphertext) // hex 编码解密
// 	// 	ciphertext: CryptoJS.enc.Base64.parse(ciphertext) // base64 编码解密
// 	// }, keyHex, {
// 	// 	mode: CryptoJS.mode.CBC, // CBC模式
// 	// 	padding: CryptoJS.pad.Pkcs7, // pkcs7padding 填充方式
// 	// 	iv: CryptoJS.enc.Utf8.parse(iv) // 设置偏移量（若 ECB 模式则删除该行）
// 	// });
// 	// return decrypted.toString(CryptoJS.enc.Utf8); // 返回 base64 编码格式
// 	let encryptedHexStr = CryptoJS.enc.Utf8.parse(ciphertext);
// 	let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
// 	let decrypt = CryptoJS.AES.decrypt(srcs, key, {
// 		iv: iv,
// 		mode: CryptoJS.mode.CBC,
// 		padding: CryptoJS.pad.Pkcs7
// 	});
// 	let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
// 	return decryptedStr.toString();
// }
//此处的密钥随机生成，可自行修改
const key = CryptoJS.enc.Utf8.parse('bXQPFvDKMa6kmTOi'); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('IigCIkFNejduC96O'); //十六位十六进制数作为密钥偏移量
//解密方法
export const decryptByDES = function(word) {
	let base64 = CryptoJS.enc.Base64.parse(word);
	word = CryptoJS.enc.Base64.stringify(base64);
	let decrypt = CryptoJS.AES.decrypt(word, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	});
	return JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
	console.log('decrypt',decrypt);
	let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
	console.log('decryptedStr',decryptedStr);
	return decryptedStr.toString();
}


//加密方法
export const encryptByDES = function(word) {
	let srcs = CryptoJS.enc.Utf8.parse(word);
	let encrypted = CryptoJS.AES.encrypt(srcs, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
}
